import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../locale";

const ConfimeaConfirmationSuccess = () => {
  return (
    <div className="confimea-confirmation-success">
      <div className="confimea-confirmation-success-header">
        <div className="confimea-confirmation-success-icon-wrapper">
          <div className="confimea-confirmation-success-icon">
            <i className="pi pi-check-circle"></i>
          </div>
        </div>
      </div>

      <div className="confimea-confirmation-success-content flex flex-column align-items-center justify-content-center">
        <div className="confimea-confirmation-success-badge mb-4">
          <i
            className="pi pi-circle-fill text-xs mr-1"
            style={{ color: "rgba(126, 229, 192, 1)" }}
          ></i>{" "}
          {localeText("documentsReceived")}
        </div>
        <h2 className="confimea-confirmation-success-title">
          {localeText("documentationSentSuccessfully")}
        </h2>
        <p className="confimea-confirmation-success-subtitle">
          {localeText("documentationSentSuccessfullySubtitle")}
        </p>

        <div className="confimea-confirmation-success-info-cards">
          <div className="confimea-confirmation-success-info-card">
            <div className="confimea-confirmation-success-info-icon">
              <i className="pi pi-envelope"></i>
            </div>
            <div className="confimea-confirmation-success-info-content">
              <h3>{localeText("emailConfirmation")}</h3>
              <p>{localeText("emailConfirmationDescription")}</p>
            </div>
          </div>

          <div className="confimea-confirmation-success-info-card">
            <div className="confimea-confirmation-success-info-icon">
              <i className="pi pi-clock"></i>
            </div>
            <div className="confimea-confirmation-success-info-content">
              <h3>{localeText("verificationTime")}</h3>
              <p>{localeText("verificationTimeDescription")}</p>
            </div>
          </div>

          <div className="confimea-confirmation-success-info-card">
            <div className="confimea-confirmation-success-info-icon">
              <i className="pi pi-shield"></i>
            </div>
            <div className="confimea-confirmation-success-info-content">
              <h3>{localeText("activationNotification")}</h3>
              <p>{localeText("activationNotificationDescription")}</p>
            </div>
          </div>
        </div>

        <div className="confimea-confirmation-success-what-next w-full">
          <div className="confimea-confirmation-success-what-next-header flex align-items-center gap-2">
            <i className="pi pi-clock text-lg font-bold"></i>
            <h3>{localeText("whatHappensNow")}</h3>
          </div>
          <ul className="confimea-confirmation-success-what-next-list">
            <li>{localeText("whatHappensNow1")}</li>
            <li>{localeText("whatHappensNow2")}</li>
            <li>{localeText("whatHappensNow3")}</li>
            <li>{localeText("whatHappensNow4")}</li>
          </ul>
        </div>

        <div className="confimea-confirmation-success-actions">
          <Link to="/login" className="confimea-btn confimea-btn-primary confimea-btn-login">
            {localeText("goToLoginPage")}
            <i className="pi pi-arrow-right ml-2"></i>
          </Link>
        </div>

        <p className="confimea-confirmation-success-privacy">{localeText("privacyNote")}</p>
      </div>
    </div>
  );
};

export default ConfimeaConfirmationSuccess;
